(() => {
  'use strict';
  async function boot(){
    const nodes=[...document.querySelectorAll('[data-ops-my-ops-badge]')];
    if(!nodes.length)return;
    try{
      const response=await fetch('/community/creators/api/my-ops/badge',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      const data=await response.json();
      if(!response.ok||!data.ok||!data.signed_in)return;
      const count=Number(data.unread_notifications||0)+Number(data.proofs_awaiting_action||0);
      nodes.forEach(node=>{node.textContent=count>99?'99+':String(count);node.hidden=count<1});
    }catch{}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
